module.exports = __webpack_public_path__ + "static/media/the-first-rule-of-punk.8d6adcb2.jpg";